import React, { createContext, useContext, useState, useEffect } from 'react';
import { encrypt, decrypt } from '../utils/crypto';

// Kullanıcı kimlik doğrulama bağlamı oluşturuluyor
export const AuthenticatedUserContext = createContext({});

export const AuthenticatedUserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isActivated, setIsActivated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const setUser = (userData) => {
    try {
      if (userData) {
        // User datasını şifrele ve sakla (token olmadan)
        const encryptedData = encrypt(userData);
        localStorage.setItem('user', encryptedData);
        setCurrentUser(userData);
        setIsActivated(userData.isActivated || false);
      } else {
        // Çıkış yapıldığında tüm verileri temizle
        localStorage.removeItem('user');
        localStorage.removeItem('authToken');
        setCurrentUser(null);
        setIsActivated(false);
      }
    } catch (error) {
      console.error('Error saving user data:', error);
    }
  };

  // Sayfa yüklendiğinde verileri kontrol et
  useEffect(() => {
    const loadUser = () => {
      try {
        setIsLoading(true);
        const encryptedUser = localStorage.getItem('user');
        const encryptedToken = localStorage.getItem('authToken');

        // Token ve user verisi varsa oturumu başlat
        if (encryptedUser && encryptedToken) {
          const userData = decrypt(encryptedUser);
          if (userData) {
            setCurrentUser(userData);
            setIsActivated(userData.isActivated || false);
          }
        }
      } catch (error) {
        console.error('Error loading user data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadUser();
  }, []);

  // Token kontrolü için yardımcı fonksiyon
  const checkAuth = () => {
    try {
      const encryptedToken = localStorage.getItem('authToken');
      if (!encryptedToken) return false;
      
      const token = decrypt(encryptedToken);
      return !!token; // token varsa ve decrypt edilebildiyse true döner
    } catch {
      // Hata durumunda token'ı temizle
      localStorage.removeItem('authToken');
      return false;
    }
  };

  // Çıkış yapma fonksiyonu - token'ı da temizle
  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setUser(null);
  };

  const value = {
    currentUser,
    setUser,
    isActivated,
    setIsActivated,
    isLoading,
    checkAuth,
    logout
  };

  // Yükleme durumunda loading göster
  if (isLoading) {
    return <div>Loading...</div>; // Burada bir loading komponenti kullanabilirsiniz
  }

  return (
    <AuthenticatedUserContext.Provider value={value}>
      {children}
    </AuthenticatedUserContext.Provider>
  );
};

export const AuthProvider = AuthenticatedUserProvider; // Alias export

// Custom hook for using auth context
export const useAuth = () => {
  const context = useContext(AuthenticatedUserContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthenticatedUserProvider');
  }
  return context;
}; 